const RemoveFilterImg = ({
  onClick,
  error,
}: {
  onClick?: () => void;
  error?: boolean;
}): JSX.Element => {
  return (
    <img
      className="self-center ml-3 h-2 `w-2"
      src={
        error
          ? '/Images/Icons/close-blue1000.svg'
          : '/Images/Icons/close-white.svg'
      }
      alt="Ikon kryss ta bort filter"
      width={12}
      height={12}
      onClick={onClick}
    />
  );
};
export default RemoveFilterImg;
